import { useCallback, useEffect, useState } from "react";

type Theme = "dark" | "light";

// v2 key: the old one was written on every visit, so it can't tell an explicit
// choice from the previous dark default. Only the toggle writes this one.
const KEY = "nh-theme-v2";

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => (localStorage.getItem(KEY) === "dark" ? "dark" : "light"));

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((t) => {
      const next = t === "dark" ? "light" : "dark";
      localStorage.setItem(KEY, next);
      return next;
    });
  }, []);

  return { theme, toggle } as const;
}
